import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './LanguageContext';
import NarkisHero from './screens/FirstScreen';
import ThirdScreen from "./screens/ThirdScreen"
import NarkisProcess from './components/process/Process';
import AboutNarkis from './components/me/Me';
import NarkisQuote from './components/quate/Quate';
import ProjectsGallery from './components/projects/ProjectsGallery';
import FAQ from './components/questions/Questions';
import ByMe from './components/ByMe/ByMe';
import MoreProjects from './screens/Projects';
import BeforeAfter from './components/BeforeAfter/BeforeAfter';
import Form from './components/Form/Form';
import PrivacyPolicy from './components/privacy/privacy';
import NarkisRec from './components/Rec/NarkisRec';
import NarkisMore from './components/shorts/Shorts';
import Navigation from './Nav/Nav';
import Guide from './components/Guide/Guide';
import GuideB from './components/Guide/GuideB';

function MainContent({ lang }) {
  return (
    <LanguageProvider lang={lang}>
      <div dir={lang === 'en' ? 'ltr' : 'rtl'}>
        <Navigation/>
        <NarkisHero/>
        <ProjectsGallery />
        <AboutNarkis/>
        <NarkisRec/>
        <NarkisQuote/>
        <ThirdScreen/>
        <NarkisProcess/>
        <MoreProjects/>
        <BeforeAfter/>
        <FAQ/>
        <NarkisMore/>
        <Form/>
        <PrivacyPolicy
          ownerName={lang === 'en' ? "Narkis Rubin Barazani" : "נרקיס רובין ברזני"}
          email="nbnarkisbarazani@gmail.com"
          phone="+972544998929"
          domain="https://narkisrubinbarazani.co.il/"
        />
        <ByMe/>
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/english" element={<MainContent lang="en" />} />
        <Route path="/מדריך" element={<Guide />} />
        <Route path="/מדריך-ב" element={<GuideB />} />
        <Route path="*" element={<MainContent lang="he" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
